var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170.993,
    height: 171,
    viewBox: "0 0 170.993 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24858",
    "data-name": "Rectangle 24858",
    width: 68.825,
    height: 69.882,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85134",
    "data-name": "Group 85134",
    transform: "translate(-539.615 -1561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85131",
    "data-name": "Group 85131",
    transform: "translate(539.615 1561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_62bc672ce0fa1d23adf660f4_check-green-icon",
    "data-name": "62bc672ce0fa1d23adf660f4_check-green-icon",
    d: "M128.7,8.611l1,1.982,7.463,19.862a5.769,5.769,0,0,0,3.381,3.381l19.175,7.2a17.348,17.348,0,0,1,10.7,20.652l-.544,1.684-8.914,19.732a5.779,5.779,0,0,0,0,4.794l8.473,18.656a17.36,17.36,0,0,1-7.048,22.155l-1.982,1-19.861,7.463a5.794,5.794,0,0,0-3.369,3.381l-7.2,19.175a17.361,17.361,0,0,1-20.665,10.7l-1.684-.544-19.731-8.914a5.78,5.78,0,0,0-4.794,0l-18.644,8.473A17.36,17.36,0,0,1,42.3,162.4l-1-1.982-7.476-19.862a5.792,5.792,0,0,0-3.382-3.369l-19.175-7.2a17.361,17.361,0,0,1-10.7-20.665l.544-1.684L10.04,87.9a5.791,5.791,0,0,0,0-4.794L1.553,64.465A17.361,17.361,0,0,1,8.588,42.31l1.982-1,19.874-7.489a5.792,5.792,0,0,0,3.382-3.382l7.2-19.175A17.361,17.361,0,0,1,61.682.566l1.684.544L83.1,10.036a5.792,5.792,0,0,0,4.794,0l18.656-8.473A17.361,17.361,0,0,1,128.7,8.6Z",
    transform: "translate(0 0)",
    fill: "#d2e5c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85117",
    "data-name": "Group 85117",
    transform: "translate(590.846 1611.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85116",
    "data-name": "Group 85116",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241232",
    "data-name": "Path 241232",
    d: "M77.736,25.038a.888.888,0,0,0-.7,1.411,2.677,2.677,0,1,1-4.453.109.979.979,0,0,0-.735-1.52H66.8v5.086a.971.971,0,0,1-1.51.74,2.645,2.645,0,0,0-1.758-.4,2.7,2.7,0,0,0,.335,5.37A2.643,2.643,0,0,0,65.4,35.35a.881.881,0,0,1,1.4.707V41.4H83.044V25.038Z",
    transform: "translate(-18.827 -7.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241233",
    "data-name": "Path 241233",
    d: "M82.928,27.993a2.68,2.68,0,0,0-.486-1.544.888.888,0,0,1,.7-1.411H80.167a.888.888,0,0,0-.7,1.411,2.7,2.7,0,0,1-.7,3.78,2.627,2.627,0,0,0,1.192.443,2.684,2.684,0,0,0,2.973-2.679",
    transform: "translate(-24.234 -7.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24855",
    "data-name": "Rectangle 24855",
    width: 2.977,
    height: 16.366,
    transform: "translate(61.241 17.334)",
    fill: "#d3f3e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241234",
    "data-name": "Path 241234",
    d: "M69.29,1.4V6.744a.88.88,0,0,0,1.4.707,2.641,2.641,0,0,1,1.533-.489,2.7,2.7,0,0,1,.334,5.37,2.647,2.647,0,0,1-1.758-.4.97.97,0,0,0-1.509.74v5.087h5.05a.979.979,0,0,1,.735,1.52,2.675,2.675,0,1,0,4.453-.109.888.888,0,0,1,.7-1.411h5.309V1.4Z",
    transform: "translate(-21.32 -0.43)",
    fill: "#27c484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241235",
    "data-name": "Path 241235",
    d: "M62.094,12.653a.97.97,0,0,1,1.509-.74,2.648,2.648,0,0,0,1.759.4,2.7,2.7,0,0,0-.335-5.37,2.643,2.643,0,0,0-1.533.489.88.88,0,0,1-1.4-.707V1.373H45.846V17.739h5.309a.887.887,0,0,0,.7-1.411,2.678,2.678,0,1,1,4.454-.109.979.979,0,0,0,.735,1.52h5.05Z",
    transform: "translate(-14.106 -0.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24856",
    "data-name": "Rectangle 24856",
    width: 2.977,
    height: 16.249,
    transform: "translate(31.74 1.068)",
    fill: "#d3f3e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241236",
    "data-name": "Path 241236",
    d: "M63.591,0a.968.968,0,1,1-.968.968A.968.968,0,0,1,63.591,0",
    transform: "translate(-19.269 0)",
    fill: "#27c484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241237",
    "data-name": "Path 241237",
    d: "M23.178,60.633l3.439-8.276,5.1,2.2-1.452,3.559a51.913,51.913,0,0,0-2.1,6.368c-.061.231-.106.467-.145.7a15.207,15.207,0,0,1-4.9,8.922,7.426,7.426,0,0,0-1.444,1.725l-1.344,2.2-9.787-4.152,1.089-3.925a7.5,7.5,0,0,0,.269-2.118l-.132-7.57a7.44,7.44,0,0,1,1.678-4.84l7.258-8.882a4.466,4.466,0,0,1,3.851-1.623l.77.068",
    transform: "translate(-3.245 -13.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241238",
    "data-name": "Path 241238",
    d: "M35.764,56.768l-2.095-.9L32.447,64.75Z",
    transform: "translate(-9.984 -17.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241239",
    "data-name": "Path 241239",
    d: "M32.115,65.164a.733.733,0,0,1-.2-.026.746.746,0,0,1-.544-.822L32.6,55.43a.745.745,0,0,1,1.035-.584l2.1.9a.746.746,0,0,1,.393.972L32.8,64.7A.746.746,0,0,1,32.115,65.164Zm1.828-8.558-.3,2.193.819-1.97Z",
    transform: "translate(-9.652 -16.857)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241240",
    "data-name": "Path 241240",
    d: "M14.165,70.7a7.445,7.445,0,0,0,.269-2.118l-.132-7.57a7.444,7.444,0,0,1,1.679-4.84l7.259-8.882A4.467,4.467,0,0,1,25.2,45.909l.127-.917-.77-.068a4.464,4.464,0,0,0-3.851,1.622l-7.259,8.882a7.448,7.448,0,0,0-1.679,4.841l.132,7.57a7.449,7.449,0,0,1-.269,2.118l-1.088,3.924,9.787,4.152.16-.261-7.417-3.147Z",
    transform: "translate(-3.245 -13.818)",
    fill: "#d3f3e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241241",
    "data-name": "Path 241241",
    d: "M43.379,45.672a2.641,2.641,0,0,1-1.533.489,2.7,2.7,0,0,1-.335-5.37,2.64,2.64,0,0,1,1.759.4.97.97,0,0,0,1.509-.74V35.36h-5.05a.979.979,0,0,1-.735-1.52,2.675,2.675,0,1,0-4.453.109.888.888,0,0,1-.7,1.411H30.02a1.488,1.488,0,0,0-1.488,1.488V50.238a1.489,1.489,0,0,0,1.488,1.489H44.779V46.379A.88.88,0,0,0,43.379,45.672Z",
    transform: "translate(-8.779 -9.141)",
    fill: "#27c484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241242",
    "data-name": "Path 241242",
    d: "M30.019,37.87a1.488,1.488,0,0,0-1.488,1.488v13.39a1.488,1.488,0,0,0,1.488,1.488h1.488V37.87Z",
    transform: "translate(-8.779 -11.652)",
    fill: "#27c484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241243",
    "data-name": "Path 241243",
    d: "M50.806,53.4a.88.88,0,0,0-1.4-.707,2.649,2.649,0,0,1-1.287.476v5.578h2.688Z",
    transform: "translate(-14.806 -16.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241244",
    "data-name": "Path 241244",
    d: "M28.792,64.34l2.355-5.668A2.787,2.787,0,0,1,36.3,60.794l-.421,1.03a52.36,52.36,0,0,0-2.192,6.724",
    transform: "translate(-8.859 -17.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241245",
    "data-name": "Path 241245",
    d: "M82.2,86.005H68.888a.747.747,0,1,1,0-1.493H82.2a.747.747,0,0,1,0,1.493",
    transform: "translate(-20.966 -26.004)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241246",
    "data-name": "Path 241246",
    d: "M96.925,86.005H94.5a.747.747,0,0,1,0-1.493h2.428a.747.747,0,0,1,0,1.493",
    transform: "translate(-28.846 -26.004)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241247",
    "data-name": "Path 241247",
    d: "M73.6,96.756H60.287a.747.747,0,1,1,0-1.493H73.6a.747.747,0,0,1,0,1.493",
    transform: "translate(-18.32 -29.312)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241248",
    "data-name": "Path 241248",
    d: "M88.324,96.756H85.9a.747.747,0,0,1,0-1.493h2.428a.747.747,0,0,1,0,1.493",
    transform: "translate(-26.2 -29.312)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24857",
    "data-name": "Rectangle 24857",
    width: 2.977,
    height: 16.384,
    transform: "translate(61.241 0.951)",
    fill: "#27c484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241249",
    "data-name": "Path 241249",
    d: "M69.29,1.4V6.744a.88.88,0,0,0,1.4.707,2.635,2.635,0,0,1,1.287-.476V1.4Z",
    transform: "translate(-21.32 -0.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241250",
    "data-name": "Path 241250",
    d: "M34.208,41.2a1.9,1.9,0,0,1,1.266.284A1.725,1.725,0,0,0,38.132,40.1V35.025a.747.747,0,0,0-.747-.747h-5.05c-.148.01-.169-.29-.1-.377a3.422,3.422,0,1,0-5.7.14.141.141,0,0,1-.089.237h-3.82a2.237,2.237,0,0,0-2.235,2.235v3a5.206,5.206,0,0,0-2.121,1.548l-7.259,8.882a8.2,8.2,0,0,0-1.847,5.325l.132,7.57a15.685,15.685,0,0,1-.847,4.087,2.231,2.231,0,0,0-2.676,1.28l-1.1,2.614a2.241,2.241,0,0,0,1.18,2.922l11.119,4.762a2.245,2.245,0,0,0,2.94-1.187l1.1-2.615a2.241,2.241,0,0,0-.971-2.818l.411-.672a6.694,6.694,0,0,1,1.3-1.551A15.865,15.865,0,0,0,26.9,60.3a44.341,44.341,0,0,1,2.149-6.784s.539-1.324.561-1.378h7.777a.747.747,0,0,0,.747-.747V46.054a1.637,1.637,0,0,0-2.59-1.318,1.9,1.9,0,0,1-1.09.343,1.95,1.95,0,0,1-.242-3.882m-6.073,10.6-.42,1.03a52.222,52.222,0,0,0-2.13,6.459c-.059.225-.11.47-.16.772a14.358,14.358,0,0,1-4.656,8.481,8.16,8.16,0,0,0-1.59,1.9l-.517.846L9.84,67.5a17.23,17.23,0,0,0,.95-4.688l-.132-7.57a6.7,6.7,0,0,1,1.511-4.355l7.259-8.882a3.672,3.672,0,0,1,.964-.831V49.9A2.237,2.237,0,0,0,22,52.046l-1.367,3.291a.747.747,0,1,0,1.379.573l2.356-5.669a2.04,2.04,0,0,1,3.772,1.554Zm6.316-5.222a3.118,3.118,0,0,0,1.964-.626.132.132,0,0,1,.223.1v4.6H29.751a3.528,3.528,0,0,0-6.767-.977l-.4.972a.74.74,0,0,1-.7-.737V36.514a.742.742,0,0,1,.741-.742h3.81a1.645,1.645,0,0,0,1.317-2.6,1.931,1.931,0,1,1,3.217-.069,1.734,1.734,0,0,0,1.373,2.665h4.3v4.34c.018.149-.275.179-.361.111a3.364,3.364,0,0,0-2.251-.507,3.449,3.449,0,0,0-2.976,3.037A3.514,3.514,0,0,0,34.451,46.573Z",
    transform: "translate(-1.385 -8.807)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241251",
    "data-name": "Path 241251",
    d: "M71.225,69.838a.746.746,0,0,1-.652-.382l-1.892-3.381a.747.747,0,1,1,1.3-.729l1.891,3.381A.751.751,0,0,1,71.225,69.838Z",
    transform: "translate(-21.103 -19.989)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241252",
    "data-name": "Path 241252",
    d: "M77.5,63.416a.745.745,0,0,1-.377-.1l-3.3-1.936a.747.747,0,0,1,.755-1.288l3.3,1.936a.751.751,0,0,1-.378,1.391",
    transform: "translate(-22.601 -18.457)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241253",
    "data-name": "Path 241253",
    d: "M62.682,72.234h-.006a.747.747,0,0,1-.741-.752l.028-3.921a.746.746,0,0,1,.746-.741h.006a.746.746,0,0,1,.741.752l-.028,3.92a.747.747,0,0,1-.746.741",
    transform: "translate(-19.057 -20.56)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241254",
    "data-name": "Path 241254",
    d: "M20.811,10.343,19.9,7.528a1.479,1.479,0,0,0-1.864-.95l-2.241.728A7.232,7.232,0,0,0,13.4,5.57V3.213a1.48,1.48,0,0,0-1.479-1.48H8.963a1.48,1.48,0,0,0-1.48,1.48V5.57a7.232,7.232,0,0,0-2.39,1.736l-2.24-.728a1.48,1.48,0,0,0-1.865.95L.073,10.343a1.48,1.48,0,0,0,.95,1.865l2.241.728a7.176,7.176,0,0,0,.913,2.808L2.791,17.651a1.48,1.48,0,0,0,.327,2.067l2.395,1.739A1.479,1.479,0,0,0,7.58,21.13l1.385-1.9a7.274,7.274,0,0,0,2.955,0l1.385,1.9a1.479,1.479,0,0,0,2.067.327l2.395-1.739a1.48,1.48,0,0,0,.327-2.067l-1.385-1.907a7.176,7.176,0,0,0,.913-2.808l2.241-.728a1.48,1.48,0,0,0,.95-1.865M10.442,15.465a3.309,3.309,0,1,1,3.309-3.309,3.309,3.309,0,0,1-3.309,3.309",
    transform: "translate(0 -0.533)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241255",
    "data-name": "Path 241255",
    d: "M77.993.311H61.745A.746.746,0,0,0,61,1.058V6.395a1.637,1.637,0,0,0,2.59,1.318,1.9,1.9,0,0,1,1.09-.343,1.95,1.95,0,0,1,.243,3.882,1.9,1.9,0,0,1-1.266-.284A1.725,1.725,0,0,0,61,12.344V16.66H56.713c-.149.01-.169-.289-.1-.377a3.422,3.422,0,1,0-5.7.14.141.141,0,0,1-.089.237H46.261V1.787h8.315a.747.747,0,0,0,0-1.493H45.514a.747.747,0,0,0-.746.747V17.407a.747.747,0,0,0,.746.746h5.3a1.644,1.644,0,0,0,1.316-2.6,1.931,1.931,0,1,1,3.217-.069,1.733,1.733,0,0,0,1.373,2.664H61v4.357c.018.149-.275.179-.361.111a3.364,3.364,0,0,0-2.251-.507,3.443,3.443,0,0,0,.426,6.857,3.383,3.383,0,0,0,1.964-.626.132.132,0,0,1,.223.1v5.347a.747.747,0,0,0,.746.747H77.993a.747.747,0,0,0,.747-.747V1.058A.747.747,0,0,0,77.993.311Zm-.746,32.733H62.491V28.454a1.637,1.637,0,0,0-2.59-1.318,1.894,1.894,0,0,1-1.09.343,1.95,1.95,0,0,1-.244-3.882,1.9,1.9,0,0,1,1.266.284A1.725,1.725,0,0,0,62.491,22.5V18.171h4.3c.147-.01.169.29.1.377a3.422,3.422,0,1,0,5.7-.14.14.14,0,0,1,.089-.237h4.562Zm0-16.366H72.694a1.644,1.644,0,0,0-1.316,2.6,1.931,1.931,0,1,1-3.217.069,1.734,1.734,0,0,0-1.374-2.665H62.51l-.018-4.341c-.018-.148.275-.178.361-.11a3.371,3.371,0,0,0,2.251.507,3.443,3.443,0,0,0-.426-6.857,3.381,3.381,0,0,0-1.964.626.132.132,0,0,1-.222-.1V1.8H77.246Z",
    transform: "translate(-13.775 -0.09)",
    fill: "#8e8e8e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution);
export default __webpack_public_path__ + "static/media/Solution.a9f63f4e7a75d30f82d26682f9d4757a.svg";
export { ForwardRef as ReactComponent };